import { render, staticRenderFns } from "./CustomizedService.vue?vue&type=template&id=ae367e88&scoped=true"
import script from "./CustomizedService.vue?vue&type=script&lang=js"
export * from "./CustomizedService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae367e88",
  null
  
)

export default component.exports